import {useEffect, useState} from 'react';
import {useAuthStore} from '@/context/auth';

export function useEditAuthService(auths) {
    const [authStore] = useAuthStore();

    const [editable, setEditable] = useState(false);

    useEffect(() => {
        setEditable(authStore.hasAuthorities(auths, 'w'));
    }, [authStore, auths]);

    return editable;
}
